module.exports = __webpack_public_path__ + "assets/IconRetUp.6d9c97d2.svg";